import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Layout, Menu, Button } from "antd";
import {
  HomeOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import mainStyles from "../../styles/Main.module.css";
import { getSession, deleteSession, getOrganizations } from "../../utils";
import Organization from "./Organization";

const { Header, Sider, Content } = Layout;

interface State {
  session: any;
  organizations: Organization[] | null;
}

class Dashboard extends Component<any, State> {
  state: State = {
    session: null,
    organizations: null,
  };

  componentDidMount() {
    const userSession = getSession();
    this.fetchOrganizations();
    this.setState({
      session: userSession,
    });
  }

  fetchOrganizations = async () => {
    const organizations = await getOrganizations();
    console.log(organizations);
    this.setState({
      organizations,
    });
  };

  /**
   * Log user out by clearing cookie and redirecting
   */
  logout = () => {
    deleteSession();
    this.props.history.push(`/login`);
  };

  render() {
    return (
      <Layout className={mainStyles.main}>
        <Sider className={mainStyles.mainSider} width={200}>
          <div className={mainStyles.siderLogo}>Brixture</div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={["organizations"]}
            items={[
              {
                key: "organizations",
                icon: <HomeOutlined />,
                label: "Organizations",
              },
            ]}
          />
        </Sider>
        <Layout>
          <Header className={mainStyles.mainHeader}>
            <div className={mainStyles.headerTitle}>Select a Organization</div>
            <div className={mainStyles.headerActions}>
              <span className={mainStyles.userEmail}>
                {this.state.session ? this.state.session.userEmail : ""}
              </span>
              <Button
                icon={<LogoutOutlined />}
                onClick={this.logout}
              >
                Logout
              </Button>
            </div>
          </Header>
          <Content className={mainStyles.container}>
            {this.state.organizations?.map((c) => (
              <Organization key={c._id} organization={c} />
            ))}
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(Dashboard);
